import React from 'react';
import { Helmet } from 'react-helmet';

// component based on Helmet (react-helmet) for improve the CEO score

export const CustomHelmet = ({
  value = '',
  title = '',
  description = '',
  canonicalLink,
  keywords
}) => {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{value || title}</title>
      <meta name="description" content={description} />
      {canonicalLink ? <link rel="canonical" href={canonicalLink} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}
    </Helmet>
  );
};
